<template>
  <div class="video-desc">
    邀請您以 3–5 分鐘的影片形式分享這次的 DFC
    挑戰歷程。可以在過程中拍攝影片，也可以將照片、文字、影片片段等素材剪輯成影片，或整理成簡報後輸出為影片。形式不限，能清楚呈現
    DFC 四階段的歷程即可。
    <br /><br />
    也可以參考<a
      href="https://youtube.com/@dfctaiwan?feature=shared"
      target="_blank"
      >其他師生分享影片</a
    >，看看大家如何呈現自己的 DFC 挑戰故事。 <br /><br />
    若您想參與 DFC 挑戰分享季，請務必上傳 DFC
    挑戰故事影片，讓我們能更完整了解貴組的挑戰歷程與故事，並作為後續分享與媒合的參考。若未參與分享季，也非常歡迎您上傳影片，為這次的
    DFC 挑戰留下完整的歷程紀錄。
    <br /><br />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {},
  components: {},
};
</script>

<style lang="scss" scoped>
.video-desc {
  font-size: 14px;
}
</style>
